import { useQuery } from "@tanstack/react-query";
import {
  AdminEngagementBlueprintActivitiesParams,
  AdminEngagementBlueprintActivitiesResponse,
  fetchAdminEngagementBlueprintActivities
} from "PFCore/services/admin/engagement_blueprints";
import { Id, QueryOptions } from "PFTypes";

import { engagementBlueprintsKeys } from "./query_keys";

export const useAdminEngagementBlueprintActivities = (
  engagementBlueprintId: Id,
  params: AdminEngagementBlueprintActivitiesParams,
  options: QueryOptions<AdminEngagementBlueprintActivitiesResponse> = {}
) =>
  useQuery<AdminEngagementBlueprintActivitiesResponse>({
    queryKey: engagementBlueprintsKeys.activities(engagementBlueprintId, params),
    queryFn: () => fetchAdminEngagementBlueprintActivities(engagementBlueprintId, params),
    ...options
  });
